module.exports = __webpack_public_path__ + "img/cash-money.b8784cad.png";